import { render } from "./Q15-ChooseView.vue?vue&type=template&id=031cb1cc&scoped=true"
import script from "./Q15-ChooseView.vue?vue&type=script&lang=js"
export * from "./Q15-ChooseView.vue?vue&type=script&lang=js"

import "./Q15-ChooseView.vue?vue&type=style&index=0&id=031cb1cc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031cb1cc"]])

export default __exports__